var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2473_2198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0039 0C5.37612 0 0.00390625 5.37222 0.00390625 12C0.00390625 18.6278 5.37612 24 12.0039 24C18.6317 24 24.0039 18.6278 24.0039 12C24.0039 5.37222 18.6307 0 12.0039 0ZM18.9563 18.269C18.9563 18.5391 18.737 18.7584 18.4669 18.7584C18.1969 18.7584 17.9776 18.5391 17.9776 18.269V10.9248L12.0049 5.23672L6.03218 10.9248V17.7787H9.36118V14.631C9.36118 14.361 9.58051 14.1417 9.85054 14.1417H14.1592C14.4293 14.1417 14.6486 14.361 14.6486 14.631V17.7787H16.4569C16.7269 17.7787 16.9462 17.998 16.9462 18.2681C16.9462 18.5381 16.7269 18.7574 16.4569 18.7574H14.1592C13.8892 18.7574 13.6699 18.5381 13.6699 18.2681V15.1204H10.3409V18.2681C10.3409 18.5381 10.1215 18.7574 9.85151 18.7574H5.54282C5.27279 18.7574 5.05346 18.5381 5.05346 18.2681V10.7142C5.05346 10.5807 5.10805 10.452 5.20553 10.3594L11.6686 4.20439C11.8577 4.02502 12.155 4.02502 12.3441 4.20439L18.8072 10.3594C18.9037 10.452 18.9592 10.5797 18.9592 10.7142V18.2681L18.9563 18.269Z",
    fill: "#1C1B1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2473_2198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.00390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.c48c217448b388f7c30d4fc6fe91a10f.svg";
export { ForwardRef as ReactComponent };